import CardWrapper from '../card-wrapper';
import Step05Image from '../../../../../assets/images/memory/onboarding/step-05-03.svg';
import { Typography } from '../../../../../core/components/molecules/Typography';
import StepButton from '../step-button';
import { Icon } from '../../../../../core/components/atoms/Icon';

const Step05D = ({
  onNextStep,
  onPreviousStep,
}: {
  onNextStep: () => void;
  onPreviousStep: () => void;
}) => {
  return (
    <CardWrapper.Root side='left'>
      <CardWrapper.Primary className='flex flex-col items-center justify-center gap-4 px-5'>
        <div className='flex w-full flex-col items-start justify-center gap-4'>
          <Typography
            title='h1'
            className='!text-h1 font-bold text-mono-color-darker'
          >
            Iniciando uma Revisão
          </Typography>
          <Typography
            title='h3'
            className='!text-h3 font-bold text-mono-color-darker'
          >
            Revisão
          </Typography>
          <Typography className='flex flex-col gap-4 !text-md !font-normal text-mono-color-darker'>
            <span>No verso, aparecerá a resposta</span>
            <span>
              E 3 opções para você escolher se o <i>flashcard</i> foi fácil,
              médio ou de difícil dificuldade. Ao escolher, o sistema irá
              organizar sua próxima revisão, baseado no nível de dificuldade que
              você escolheu de cada <i>flashcard</i>.
            </span>
          </Typography>
        </div>
        <div className='flex w-full justify-end'>
          <StepButton label='Voltar' onClick={onPreviousStep} type='text' />
          <StepButton
            label='Continuar'
            onClick={onNextStep}
            icon={<Icon Icon={'keyboard_arrow_right'} type='material' />}
          />
        </div>
      </CardWrapper.Primary>
      <CardWrapper.Secondary className='h-[438px] w-[554px]'>
        <img
          src={Step05Image}
          alt='Step 05-D'
          className='h-full w-full rounded-lg md:object-cover'
        />
      </CardWrapper.Secondary>
    </CardWrapper.Root>
  );
};

export default Step05D;
